import React, { useEffect } from "react";

const parameterValueComponents = {
  'integer': (props) => {
    return <input
      className="form-control rule-expression-parameter-node"
      style={{ width: '5rem' }}
      type="number"
      name={props.name}
      required min={0}
      value={props.value}
      onChange={(e) => props.onChange(null, props.name, parseInt(e.target.value, 10))} />
  },
  'string': (props) => {
    return <textarea className="form-control rule-expresssion-parameter-node" name={props.name} value={props.value || ''} onChange={props.onChange} cols={40} rows={10} />
  },
  'message': (props) => {
    return <textarea name={props.name} required minLength={6} maxLength={500} />
  },
  'clientMessage': ({
    name,
    value,
    def,
    defaultLang,
    onChange,
  }) => {
    const options = def.valueType.options.values.map(({ key, name }) => <option key={key} value={key}>{name[defaultLang]}</option>);
    return <select onChange={onChange} value={value} name={name} required>
      {options}
    </select>
  },
  'voucherDef': ({
    def,
    name,
    value,
    defaultLang = 'fi',
    onChange,
    translator: t = (key, params) => key,
  }) => {
    const options = def.valueType.options.values.map(({ key, name }) => <option key={key} value={key}>{name[defaultLang]}</option>);

    return <select className="form-select rule-expression-parameter-node" style={{ width: 'unset' }} onChange={onChange} value={value} name={name} required>
      {options}
    </select>;
  },
  'periodUnit': ({
    def,
    name,
    value,
    onChange,
    translator: t = (key, params) => key,
  }) => {
    const valueType = def.valueType
    const values = Array.from(new Map(valueType.options.values.map(v => [v, t(`ruleEditor.periodUnit.${v}`)])));

    const options = values.map(([k, v]) => {
      return (
        <option key={k} value={k}>{v}</option>
      );
    });

    const defaultVal = valueType.options.defaultValue;

    return <select name={name} value={value || defaultVal} onChange={onChange} style={{}}>{options}</select>
  }
};

const ExpressionParameterNode = ({
  name,
  value,
  def,
  onChange
}) => {

  const valueType = def.valueType;

  const valueComponentKey = typeof valueType === 'object' ? valueType.key : valueType.toLowerCase();

  const ParameterValueEditor = parameterValueComponents[valueComponentKey] ? parameterValueComponents[valueComponentKey] : (props) => <span />;

  useEffect(() => {
    if (def.valueType.options?.values?.length > 0 && value === undefined) {
      onChange(null, name, def.valueType.options.values[0].key);
    }
  }, []);

  return <ParameterValueEditor name={name} def={def} value={value?.key || value} onChange={onChange} />
};

export default ExpressionParameterNode;
